export default __webpack_public_path__ + "static/media/nfc2.f513c1df.jpg";